import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import AccessibleTextArea from '@bibliocommons/deprecated-base-accessibility-text-area';
import { PrimaryButton } from '@bibliocommons/deprecated-base-buttons';

export default function CommentableForm({ value, handleMessageChange, selectedCategory }) {
  return (
    <div>
      <div className="form-group">
        <label id="feedback-message-label" htmlFor="feedback-message" className="sr-only">
          <FormattedMessage id="feedback_comment_label" />
        </label>
        <AccessibleTextArea
          maxLength={4000}
          required
          value={value}
          id="feedback-message"
          labelledById="feedback-message-label"
          handleChange={handleMessageChange}
          rows="5"
          cols="60"
        />
      </div>

      <div className="text-right form-group">
        <PrimaryButton type="submit" disabled={selectedCategory === null}>
          <FormattedMessage id="button_submit" />
        </PrimaryButton>
      </div>
    </div>
  );
}

CommentableForm.propTypes = {
  selectedCategory: PropTypes.string,
  handleMessageChange: PropTypes.func.isRequired,
  value: PropTypes.string
};

CommentableForm.displayName = 'CommentableForm';
